import React from 'react';
import { createBrowserRouter, Navigate } from 'react-router-dom';
import { PublicLayout } from './components/layout/PublicLayout';
import { MainLayout } from './components/layout/MainLayout';
import { AdminLayout } from './components/layout/AdminLayout';
import { AuthGuard } from './components/layout/AuthGuard';
import { AdminGuard } from './components/layout/AdminGuard';

// Public Pages
import LandingPage from './pages/LandingPage';

// Main App Pages
import Dashboard from './pages/Dashboard';
import Optimize from './pages/Optimize';
import TenantSettings from './pages/TenantSettings';
import TenantOnboarding from './pages/TenantOnboarding';
import UserProfile from './pages/UserProfile';
import Billing from './pages/Billing';
import TeamManagement from './pages/TeamManagement';

// Admin Pages
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminClients from './pages/admin/AdminClients';
import AdminDestinations from './pages/admin/AdminDestinations';
import AdminAirports from './pages/admin/AdminAirports';
import AdminHotels from './pages/admin/AdminHotels';

// Auth Pages
import Login from './pages/auth/Login';
import Register from './pages/auth/Register';
import EmailConfirm from './pages/auth/EmailConfirm';
import ForgotPassword from './pages/auth/ForgotPassword';
import ResetPassword from './pages/auth/ResetPassword';
import AdminLogin from './pages/auth/AdminLogin';

export const router = createBrowserRouter([
  // Public landing page
  {
    path: '/',
    element: <PublicLayout />,
    children: [
      {
        index: true,
        element: <LandingPage />,
      },
    ],
  },
  
  // Public Auth routes
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/register',
    element: <Register />,
  },
  {
    path: '/auth/confirm',
    element: <EmailConfirm />,
  },
  {
    path: '/auth/forgot-password',
    element: <ForgotPassword />,
  },
  {
    path: '/auth/reset-password',
    element: <ResetPassword />,
  },
  {
    path: '/admin/login',
    element: <AdminLogin />,
  },
  
  // Protected main app routes
  {
    path: '/app',
    element: (
      <AuthGuard>
        <MainLayout />
      </AuthGuard>
    ),
    children: [
      {
        index: true,
        element: <Dashboard />,
      },
      {
        path: 'dashboard',
        element: <Dashboard />,
      },
      {
        path: 'optimize',
        element: <Optimize />,
      },
      {
        path: 'onboarding',
        element: <TenantOnboarding />,
      },
      {
        path: 'profile',
        element: <UserProfile />,
      },
      {
        path: 'tenant',
        element: <TenantSettings />,
      },
      {
        path: 'billing',
        element: <Billing />,
      },
      {
        path: 'team',
        element: <TeamManagement />,
      },
    ],
  },
  
  // Protected admin routes
  {
    path: '/admin',
    element: (
      <AuthGuard>
        <AdminGuard>
          <AdminLayout />
        </AdminGuard>
      </AuthGuard>
    ),
    children: [
      {
        index: true,
        element: <Navigate to="/admin/dashboard" replace />,
      },
      {
        path: 'dashboard',
        element: <AdminDashboard />,
      },
      {
        path: 'clients',
        element: <AdminClients />,
      },
      {
        path: 'destinations',
        element: <AdminDestinations />,
      },
      {
        path: 'airports',
        element: <AdminAirports />,
      },
      {
        path: 'hotels',
        element: <AdminHotels />,
      },
    ],
  },
  
  // Catch all - redirect to dashboard
  {
    path: '*',
    element: <Navigate to="/" replace />,
  },
]);
